export type ManualPresenceStatus = 'busy' | 'dnd' | 'away' | null;
const keyFor = (userId = 'anonymous') => `AX1_PRESENCE_MANUAL_STATUS:${userId}`;
const DEFAULT_DURATION_MS = 60 * 60 * 1000;

/** Overrides are per account and expire; a shared browser must not inherit DND. */
export function getManualPresenceStatus(userId?: string): ManualPresenceStatus {
  try {
    const stored = JSON.parse(localStorage.getItem(keyFor(userId)) || 'null');
    if (stored && stored.expiresAt > Date.now() && ['busy', 'dnd', 'away'].includes(stored.status)) return stored.status;
  } catch { /* Invalid or unavailable browser storage. */ }
  return null;
}

export function setManualPresenceStatus(status: ManualPresenceStatus, userId?: string, durationMs = DEFAULT_DURATION_MS): void {
  try {
    if (status) localStorage.setItem(keyFor(userId), JSON.stringify({ status, expiresAt: Date.now() + durationMs }));
    else localStorage.removeItem(keyFor(userId));
  } catch { /* Automatic presence remains available without persistence. */ }
}

export function hasManualPresenceStatus(userId?: string): boolean {
  return getManualPresenceStatus(userId) !== null;
}
